import { render, staticRenderFns } from "./DeParaRouterView.vue?vue&type=template&id=60a2184b"
import script from "./DeParaRouterView.vue?vue&type=script&lang=js"
export * from "./DeParaRouterView.vue?vue&type=script&lang=js"
import style0 from "./DeParaRouterView.vue?vue&type=style&index=0&id=60a2184b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports